import React, {useState} from 'react';
import axios from 'axios';
import './Styles/login.css';
import config from '../config';
import QrCodeIcon from '@mui/icons-material/QrCode';

export default function Login() {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const login = () => {
    axios.post(`${config.apiEndpoint}/Account/login`, {
      username: username,
      password: password
    }, {withCredentials: true}).then(res => {
      if (res.data.token) {
        console.log('Login success:', res.data);
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('full_user', JSON.stringify(res.data));
        window.location.href = '/';
      }
    }).catch(error => {
      console.error('Login failed:', error);
      alert('Login failed: ' + error.response.data.message);
    });
  };

  const goToQrLookup = () => {
    window.location.href = '/qr-lookup';
  };

  return (<div className="bodyWrap">
    <div className="contentLoginWrap">
      <div className="loginSide">
        <div className="loginWrap">
          <h1>Log in</h1>
          <div className="input-group">
            <input type="text" className="input" onChange={e => setUsername(e.target.value)} required="required"/>
            <label className={`${username.length > 0 ? "focusLabel" : ""}`}>Login</label>
          </div>
          <div className="input-group">
            <input type="text" className="input password" onChange={e => setPassword(e.target.value)} required="required"/>
            <label className={`${password.length > 0 ? "focusLabel" : ""}`}>Password</label>
          </div>
          <div style={{ display: "flex", gap: "10px", width: "100%" }}>
            <button onClick={login} style={{ flex: 1 }}>Login</button>
            <button 
              onClick={goToQrLookup}
              style={{
                flex: 1,
                backgroundColor: "#e0e0e0",
                color: "#333",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px"
              }}
            >
              <QrCodeIcon style={{ fontSize: "20px" }} />
              <span>Tra cứu mã QR</span>
            </button>
          </div>
        </div>
      </div>
      <div className="infoSide">
        <div className="loginWrap">
          <h2>Hello again!</h2>
          <p>Log in to your account to get access to app.</p>
        </div>
      </div>
    </div>
  </div>)
}
